import { withCarouselContainer } from '@recommendations-fe/commons';
import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import 'prop-types';
import classNames from 'classnames';
import { Image } from 'frontend-image';
import MoneyAmount from '@andes/money-amount';
import CardAndes from '@andes/card';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const namespace$1 = 'mshops-card-variation-original';
const MShopsCardVariationOriginal = _ref => {
  let {
    item,
    shops,
    advertising,
    slidesLength,
    IconFactory
  } = _ref;
  const {
    discount,
    shipping,
    image,
    title,
    price,
    installments,
    id
  } = item;
  const src = image === null || image === void 0 ? void 0 : image.src;
  const src2x = image === null || image === void 0 ? void 0 : image.src2x;
  const isMLA = id.substring(0, 3) === 'MLA';
  return /*#__PURE__*/_jsx(CardAndes, {}, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__container")
  }, void 0, /*#__PURE__*/_jsx("a", {
    href: shops.url_click,
    className: "".concat(namespace$1, "__header"),
    target: "_blank",
    rel: "noreferrer"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__header-container")
  }, void 0, /*#__PURE__*/_jsx("p", {
    className: "".concat(namespace$1, "__header-name\n              ").concat(namespace$1, "__header-name--").concat(slidesLength)
  }, void 0, shops.name))), /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__content")
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__item-box")
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__image-container")
  }, void 0, /*#__PURE__*/_jsx(Image, {
    className: "".concat(namespace$1, "__item-image"),
    alt: "",
    src: src || '',
    srcSet: src && src2x ? "".concat(src, " 1x, ").concat(src2x, " 2x") : ''
  })), /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__info-container ").concat(namespace$1, "__info-container--").concat(slidesLength)
  }, void 0, /*#__PURE__*/_jsx("p", {
    className: "".concat(namespace$1, "__item-name\n                  ").concat(namespace$1, "__item-name--").concat(slidesLength)
  }, void 0, /*#__PURE__*/_jsx("a", {
    href: advertising.click_url,
    target: "_blank",
    rel: "noreferrer",
    className: "".concat(namespace$1, "__link-title")
  }, void 0, title)), (discount === null || discount === void 0 ? void 0 : discount.original_price.fraction) && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__discount\n                    ").concat(namespace$1, "__discount--").concat(slidesLength)
  }, void 0, /*#__PURE__*/_jsx("p", {
    className: "".concat(namespace$1, "__discount-price")
  }, void 0, discount.original_price.symbol, " ", discount.original_price.fraction), /*#__PURE__*/_jsx("p", {
    className: "".concat(namespace$1, "__discount-text")
  }, void 0, discount.text)), /*#__PURE__*/_jsx("p", {
    className: "".concat(namespace$1, "__item-price\n              ").concat(namespace$1, "__item-price--").concat(slidesLength)
  }, void 0, /*#__PURE__*/_jsx(MoneyAmount, {
    value: {
      fraction: price.fraction
    },
    symbol: price.symbol,
    suffix: price.suffix,
    size: 14,
    compact: true
  })), installments && installments.freeInstallments && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__installments")
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace$1, "__installments-text-free")
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace$1).concat(isMLA ? '' : '__installments-before-text')
  }, void 0, installments === null || installments === void 0 ? void 0 : installments.before_text), /*#__PURE__*/_jsx("span", {}, void 0, installments === null || installments === void 0 ? void 0 : installments.quantity, installments === null || installments === void 0 ? void 0 : installments.middle_text), /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/_jsx("span", {}, void 0, installments === null || installments === void 0 ? void 0 : installments.symbol, " "), /*#__PURE__*/_jsx("span", {}, void 0, installments === null || installments === void 0 ? void 0 : installments.fraction)), /*#__PURE__*/_jsx("span", {}, void 0, installments === null || installments === void 0 ? void 0 : installments.after_text))), installments && !installments.freeInstallments && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "__installments")
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace$1, "__installments-text")
  }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, installments === null || installments === void 0 ? void 0 : installments.quantity, "x "), /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/_jsx("span", {}, void 0, installments === null || installments === void 0 ? void 0 : installments.symbol, " "), /*#__PURE__*/_jsx("span", {}, void 0, installments === null || installments === void 0 ? void 0 : installments.fraction)))), /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace$1, "__shipping")
  }, void 0, shipping && shipping.text && /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace$1, "__shipping-text")
  }, void 0, shipping.text), shipping && shipping.fullfilment && IconFactory(RECOMMENDATIONS_FULL_ICON, "".concat(namespace$1, "__shipping-fullfilment"))))))));
};
var Card = MShopsCardVariationOriginal;
const namespace = 'mshops-pads-variation-original';
const Shops = _ref => {
  let {
    className = '',
    layout = '',
    items,
    subtitle = {},
    IconFactory
  } = _ref;
  const componentClassNames = classNames("".concat(namespace, "__container"), "".concat(namespace, "__client-").concat(layout), className);
  const slidesLength = items.length;
  const itemsGrid = classNames("".concat(namespace, "__items--").concat(layout), {
    'mshops-pads-variation-original__items-grid-4': Array.isArray(items) && slidesLength >= 4,
    'mshops-pads-variation-original__items-grid-2': Array.isArray(items) && slidesLength === 2
  });
  return items && items.length > 0 && /*#__PURE__*/_jsx("div", {
    className: componentClassNames
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__header")
  }, void 0, IconFactory(RECOMMENDATIONS_MSHOPS_LOGO), /*#__PURE__*/_jsx("p", {
    className: "".concat(namespace, "__header-text\n          ").concat(namespace, "__header-text--").concat(layout)
  }, void 0, subtitle.text_shops)), /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__items-container")
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(itemsGrid)
  }, void 0, Array.isArray(items) && items.map(slide => /*#__PURE__*/_jsx(Card, {
    shops: slide.shops,
    advertising: slide.advertising,
    item: slide,
    slidesLength: slidesLength,
    layout: layout,
    IconFactory: IconFactory
  }, slide.id))), (subtitle.show_ads_link || subtitle.show_shops_link) && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__cta")
  }, void 0, subtitle.show_ads_link && /*#__PURE__*/_jsx("a", {
    href: subtitle.url,
    target: "_blank",
    rel: "noreferrer",
    className: "".concat(namespace, "__no-border")
  }, void 0, subtitle.text), subtitle.show_shops_link && /*#__PURE__*/_jsx("a", {
    href: subtitle.url_shops,
    target: "_blank",
    rel: "noreferrer",
    className: "".concat(namespace, "__no-border")
  }, void 0, subtitle.text_link_shops))));
};
var RecommendationsShopsWithoutContainer = Shops;
const RecommendationsShops = withCarouselContainer(RecommendationsShopsWithoutContainer);
export { RecommendationsShops, RecommendationsShopsWithoutContainer };
